import { Modal, Stack } from '@mui/joy';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingModal from '@MP/shared/components/mobile/LoadingModal';

import MHomeRing from './MHomeRing';

/** 재택 트리 로딩 인디케이터 — 진입 스플래시와 같은 호흡 링을 쓴다. */
export const MHomeLoadingModal: FC<{ open: boolean }> = ({ open }) => (
  <Modal open={open} sx={{ '& .MuiModal-backdrop': { bgcolor: 'rgba(250,251,252,0.88)' } }}>
    <Stack
      role="status"
      aria-label="불러오는 중"
      alignItems="center"
      justifyContent="center"
      sx={{ height: '100%', outline: 'none', '&:focus-visible': { outline: 'none' } }}>
      <MHomeRing />
    </Stack>
  </Modal>
);

/**
 * 같은 배송/반납 페이지가 레거시(`/m/delivery/*`)와 재택(`/m/hm/*`) 두 트리에서 재사용되므로
 * 현재 경로에 맞는 로딩 인디케이터를 고른다 — 재택은 호흡 링, 레거시는 기존 화면 그대로.
 */
export const MDeliveryLoadingModal: FC<{ open: boolean }> = ({ open }) => {
  const isStimHome = useLocation().pathname.startsWith('/m/hm');
  return isStimHome ? <MHomeLoadingModal open={open} /> : <LoadingModal open={open} />;
};
